// Package imports
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import Loadable from "react-loadable";
import HomeIcon from "@material-ui/icons/Home";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Static js imports
import Svg from "./Svg"
import Animation from "./animation/Animation"
import Loading from "./views/Loading"

// Static assets
// import thcLogo from "./images/logo/thc.png";
import jmpLogo from "./images/logo/jmp-logo.png";
import "./App.css";

// Asynchronous imports
//Main Links
const Home = Loadable({
	loader: () => import("./views/Home"),
	loading: () => { return null },
});
const About = Loadable({
	loader: () => import("./views/About"),
	loading: () => { return null },
});
const Publications = Loadable({
	loader: () => import("./views/Publications"),
	loading: () => { return null },
});
const Teams = Loadable({
	loader: () => import("./views/Teams"),
	loading: () => { return null },
});
const Contact = Loadable({
	loader: () => import("./views/Contact"),
	loading: () => { return null },
});

//Teams
const Thc = Loadable({
	loader: () => import("./views/Teams/Thc"),
	loading: () => { return null },
});
const ThcAbout = Loadable({
	loader: () => import("./views/Teams/ThcAbout"),
	loading: () => { return null },
});
const ThcUpdates = Loadable({
	loader: () => import("./views/Teams/ThcUpdates"),
	loading: () => { return null },
});

//Publications
const Cmii = Loadable({
	loader: () => import("./views/Publications/Cmii"),
	loading: () => { return null },
});

const TcsAbout = Loadable({
	loader: () => import("./views/Publications/Tcs/TcsAbout"),
	loading: () => { return null },
});
const TcsChapter = Loadable({
	loader: () => import("./views/Publications/Tcs/TcsChapter"),
	loading: () => { return null },
});

const HtdasAbout = Loadable({
	loader: () => import("./views/Publications/Htdas/HtdasAbout"),
	loading: () => { return null },
});
const HtdasChapter = Loadable({
	loader: () => import("./views/Publications/Htdas/HtdasChapter"),
	loading: () => { return null },
});

const PawtftAbout = Loadable({
	loader: () => import("./views/Publications/Pawtft/PawtftAbout"),
	loading: () => { return null },
});
const PawtftChapter = Loadable({
	loader: () => import("./views/Publications/Pawtft/PawtftChapter"),
	loading: () => { return null },
});
const MccbAbout = Loadable({
	loader: () => import("./views/Publications/Mccb/MccbAbout"),
	loading: () => { return null },
});
const MccbContents = Loadable({
	loader: () => import("./views/Publications/Mccb/MccbContents"),
	loading: () => { return null },
});
const MccbChapter = Loadable({
	loader: () => import("./views/Publications/Mccb/MccbChapter"),
	loading: () => { return null },
});

//View 404
const View404 = Loadable({
	loader: () => import("./views/View404"),
	loading: () => { return null },
});

class App extends React.Component {

	constructor(props) {
		super(props);
		// State changes update the necessary DOM elements
		this.state = {
			// Whether the SVG has loaded and is ready for animation
			svgReady: false,
			// Stores current path for app-content
			path: props.location.pathname,
		};
		// Hardcoded view endpoints
		this.views = [
			// Views which match one-to-one with path and component
			// Add homesplash svg into #splashSvg group to get opacities to work on the various groups

			//Main level links
			{ view: "home", path: "/", content: <Home />, viewBox: "496 266 400 450", background: "#D1AC76", g: "#home-base" },
			{ view: "about", path: "/about", content: <About />, viewBox: "670.5 390.5 16.7 20.8", background: "#347F4E", g:"#network"},
			{ view: "contact", path: "/contact", content: <Contact />, viewBox: "801.8 637.8 8 10", background: "#BF7C78", g: "#shell"},
			{ view: "publications", path: "/publications", content: <Publications />, viewBox: "808.8 432.1 9.6 12.0", background: "#749E74", g: "#ferns"},
			{ view: "teams", path: "/teams", content: <Teams />, viewBox: "810.8 530.2 24.5 30.6", background: "#1e4c70", g: "#skeleton", hasAnimation: true},
			
			//Teams
			{ view: "thc", path: "/thc", content: <Thc />, viewBox: "817.3 534.9 11.4 14.2", background: "#1e4c70", g: "#skeleton"},
			{ view: "thcAbout", path: "/thc/about", content: <ThcAbout />, viewBox: "824.4 540.0 8 10", background: "#1e4c70", g: "#skeleton", hasAnimation: true},
			{ view: "thcUpdates", path: "/thc/updates", content: <ThcUpdates />, viewBox: "823.2 533.1 8 10", background: "#1e4c70", g: "#skeleton", hasAnimation: true},
			
			//Publication sublinks,
			{ view: "tcsAbout", path: "/tcs", content: <TcsAbout />, viewBox: "814.8 442.5 .2 .25", background: "#A2B8A3", g: "#ferns"},
			{ view: "cmii", path: "/cmii", content: <Cmii />, viewBox: "810.9 437.9 .2 .25", background: "#A2B8A3", g: "#ferns"},

			// HTDAS sublinks
			{ view: "htdasAbout", path: "/htdas", content: <HtdasAbout />, viewBox: "810.8 441.1 .2 .25", background: "#A2B8A3", g: "#ferns"},
						
			// PAWTFT sublinks
			{ view: "pawtftAbout", path: "/pawtft", content: <PawtftAbout />, viewBox: "812.8 434.3 .2 .25", background: "#A2B8A3", g: "#ferns"},

			// MCCB Sublinks
			{ view: "mccbAbout", path: "/mccb", content: <MccbAbout />,  viewBox: "816.8 437.5 .2 .25", background: "#A2B8A3", g: "#ferns"},
			// { view: "mccbBook", path: "/mccb/book", content: <MccbBook />, viewBox: "807.3 429.9 10 10", background: "#1e4c70", g: "#skeleton", hasAnimation: true },
			{ view: "mccbContents", path: "/mccb/contents", content: <MccbContents />, viewBox: "816.8 437.5 .2 .25", background: "#A2B8A3", g: "#ferns"},
			
			// hard-coded chapter endpoints 
			// TODO: Integrate Routes instead of explicit path comparison, so can tidy this!
			{ view: "mccbChapter", path: "/mccb/chapter/foreword", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/intro", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/a", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/b", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/c", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/d", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/e", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/f", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/g", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/h", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/j", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/k", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/l", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/m", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/n", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/p", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/q", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/r", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "mccbChapter", path: "/mccb/chapter/conclusion", content: <MccbChapter />, viewBox: "816.8 437.5 .2 .25", background: "#D0D2D3", g: "#ferns"},
			
			{ view: "pawtftChapter", path: "/pawtft/chapter/1", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/2", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/3", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/4", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/5", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/6", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/7", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/8", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/intro", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/9", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/10", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/11", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/12", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/13", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/14", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/15", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/16", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/17", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/18", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/19", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/20", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/21", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/22", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/23", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/24", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/25", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/26", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/27", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/28", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/29", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},
			{ view: "pawtftChapter", path: "/pawtft/chapter/epilogue", content: <PawtftChapter />,  viewBox: "812.8 434.3 .2 .25", background: "#D0D2D3", g: "#ferns"},

			{ view: "htdasChapter", path: "/htdas/chapter/1", content: <HtdasChapter />, viewBox: "810.8 441.1 .2 .25", background: "#A2B8A3", g: "#ferns"},
			{ view: "htdasChapter", path: "/htdas/chapter/2", content: <HtdasChapter />, viewBox: "810.8 441.1 .2 .25", background: "#A2B8A3", g: "#ferns"},
			{ view: "htdasChapter", path: "/htdas/chapter/3", content: <HtdasChapter />, viewBox: "810.8 441.1 .2 .25", background: "#A2B8A3", g: "#ferns"},
			{ view: "htdasChapter", path: "/htdas/chapter/4", content: <HtdasChapter />, viewBox: "810.8 441.1 .2 .25", background: "#A2B8A3", g: "#ferns"},
			{ view: "htdasChapter", path: "/htdas/chapter/5", content: <HtdasChapter />, viewBox: "810.8 441.1 .2 .25", background: "#A2B8A3", g: "#ferns"},

			{ view: "tcsChapter", path: "/tcs/chapter/1", content: <TcsChapter />, viewBox: "814.8 442.5 .2 .25", background: "#A2B8A3", g: "#ferns"},

			// Special case views
			{ view: "loading", path: null, content: <Loading />, viewBox: "0 0 240 270"},
			{ view: "404", path: null, content: <View404 />, viewBox: "474 213 525 525", background: "#808080", g: "#wormhole"},
		];
	}

	componentDidMount() {
		// Show loading if necessary
	}

	handleSvgReady() {
		this.setState({
			svgReady: true,
		});
	}

	handleAnimationEnd() {
		// Show the content
		document.querySelector("#App-viewbox").removeAttribute("hide");
	}

	handleTransitionEnd() {
		var view = this.views.find((v) => v.path === this.state.path) || this.views.find((v) => v.view === "404");
		// If an animation is associated with this view, fire it,
		// otherwise just show the content
		if (view.hasAnimation) {
			document.querySelector("#Animation-viewbox").removeAttribute("hide");
			this.animation.animate();
		} else {
			document.querySelector("#App-viewbox").removeAttribute("hide");
		}
	}

	renderViewBoxStyle(view) {
		// Can put in special cases depending on path or view here
		var viewException = [
			"/",
			"/teams",
			"/publications",
			"/thc",
			"/contact",
		];
		if (viewException.includes(view.path)===true) {
			var vb = view.viewBox.split(" ").map(Number);
			return {
				maxWidth: "calc("+(vb[2]/vb[3]*100)+"vh)",
				maxHeight: "calc("+(vb[3]/vb[2]*100)+"vw)",
			}
		}
		
		return {
			maxWidth: "100%",
			maxHeight: "100%",
			
		}
	}
	renderBackArrow(view) {
		// Can put in special cases depending on path or view here
		// Navigation hardcoded

		// Navigation for MCCB chain
		if (view.path.includes("/mccb/chapter")===true) {
			return (
				<Link to="/mccb/contents"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);
		} else if (view.path === "/mccb/contents") {
			return (
				<Link to="/mccb"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} else if (view.path === "/mccb") {
			return (
				<Link to="/publications"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} 
		// Navigation for PaWTFT chain
		  else if (view.path.includes("/pawtft/chapter")===true) {
			return (
				<Link to="/pawtft"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} else if (view.path === "/pawtft") {
			return (
				<Link to="/publications"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} 

		// Navigation for HTDAS chain
		else if (view.path.includes("/htdas/chapter")===true) {
			return (
				<Link to="/htdas"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} else if (view.path === "/htdas") {
			return (
				<Link to="/publications"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} 
		
		  else if (view.path === "/publications") {
			return (
				<Link to="/"><ArrowBackIcon style={{ fontSize: 35 }}/></Link>
			);	 
		} else {
			return (
				<a href="javascript:history.back()"><ArrowBackIcon style={{ fontSize: 35 }}/></a>
			);
		}	
	}

	isReady() {
		return (this.state.svgReady)
		// FOR TESTING:
		// return false
	}

	renderLoading() {
		if (!this.isReady()) {
			return this.views.find((v) => v.view === "loading").content;
		} else {
			return null
		}
	}

	renderView() {
		// If items still loading return the loading view
		if (!this.isReady()) {
			return null
		}
		// Get current and target paths
		var path = this.state.path;
		var targetPath = this.props.location.pathname;
		// Set view, default to 404
		var view = this.views.find((v) => v.path === path) || this.views.find((v) => v.view === "404");
		// Current path and target path do not match: 
		// hide content and schedule path state change and svgTransition
		if (path !== targetPath) {
			document.querySelector("#App-viewbox").setAttribute("hide", "");
			document.querySelector("#Animation-viewbox").setAttribute("hide", "");
			setTimeout(function () {
				this.setState({ path: targetPath });
			}.bind(this), 400);
		}
		// Trigger the transition
		else {
			this.svg.transition(view);
		}
		// Return view content with `location` prop attached
		var content = React.cloneElement(view.content, { location: this.state.path });
		return content;
	}

	renderFooter() {
		if (this.state.path==="/") {
			return <img src={jmpLogo} className="App-logo" alt="logo" big="" />;
		} else {
			return <img src={jmpLogo} className="App-logo" alt="logo"/>;
		}
	}

	

	render() {
		// Set view, default to 404
		var view = this.views.find((v) => v.path === this.state.path) || this.views.find((v) => v.view === "404");
		return (
			<div id="App">

				{/* SVG background */}
				<Svg
					onRef={ref => this.svg = ref}
					onReady={this.handleSvgReady.bind(this)} 
					onTransitionEnd={this.handleTransitionEnd.bind(this)} />

				{/* Loading */}
				<div id="App-loading">
					{this.renderLoading()}
				</div>

				{/* Header */}
				<header className="App-header">
					<Link to="/"><HomeIcon style={{ fontSize: 35 }}/></Link>
					{this.renderBackArrow(view)}
					{/* <Link to="/about">About</Link>
					<Link to="/contact">Contact</Link> */}
				</header>

				{/* App content */}
				<div id="App-content">
					<div id="App-viewbox-container" style={this.renderViewBoxStyle(view)}>
						<div id="App-viewbox" hide="">
							{this.renderView()}
						</div>
						<div id="Animation-viewbox" hide="">
							<Animation
								onRef={ref => this.animation = ref}
								view={view} 
								onAnimationEnd={this.handleAnimationEnd.bind(this)} />
						</div>
					</div>
				</div>

				{/* Footer */}
				<div id="App-footer">
				<div>
					{this.renderFooter()}
				</div>
				
				</div>
				<div id="Footer-author">
					Designed by Pang Pang &amp;&nbsp; <br />
					Jacksonian Institute &nbsp;

				</div>

			</div>
		);
	}
}

// withRouter binds { history, location, match } props to App
App = withRouter(App);
export default App;



// WEBPACK FOOTER //
// ./src/App.js